module.exports = __webpack_public_path__ + "img/wild_comming.364df112.png";